<header class="border-b border-slate-200 px-4 py-4 sm:px-5">
  <div class="flex flex-col gap-4 lg:flex-row lg:items-end lg:justify-between">
    <div>
      <p class="text-2xl font-semibold tracking-tight text-slate-900 sm:text-[1.7rem]">
        Mica-Chat CRM
      </p>
      <p class="mt-1 text-sm text-slate-500">Gestión completa de WhatsApp Business</p>
    </div>

    <div class="flex flex-row items-center gap-4">
      <div class="flex flex-col gap-1">
        <select
          class="w-full rounded-lg border border-slate-200 bg-white p-1 text-sm text-slate-700 shadow-sm outline-none focus:border-sky-400 focus:ring-2 focus:ring-sky-100"
          [value]="$safeNavigationMigration(micaChatService.telefonoSeleccionadoSignal()?.id)"
          (change)="onChangeTelefono($event)"
        >
          @for (telefono of telefonos(); track telefono.id) {
            <option [value]="telefono.id">
              {{ telefono.titulo }} - {{ telefono.numero }}
              @if (telefono.proveedor === 'NO_OFICIAL') {
                [No Oficial]
              }
              @if (telefono.usar_para_comprobantes) {
                [Comprobantes]
              }
            </option>
          }
        </select>
        @if (telefonoComprobantes()) {
          <div class="flex items-center gap-1 text-xs text-green-700">
            <span class="h-2 w-2 rounded-full bg-green-500"></span>
            Comprobantes: {{ telefonoComprobantes()?.titulo }}
          </div>
        }
      </div>

      @if (estadoConexion()) {
        <div
          class="flex items-center gap-3 self-start rounded-full border px-3 py-1.5 text-xs font-medium shadow-sm"
          [class]="{
            'border-emerald-200 bg-emerald-50 text-emerald-700':
              estadoConexion()?.estado === 'conectado',
            'border-yellow-200 bg-yellow-50 text-yellow-700':
              estadoConexion()?.estado === 'conectando',
            'border-red-200 bg-red-50 text-red-700': estadoConexion()?.estado === 'desconectado',
          }"
        >
          <span class="h-2 w-2 rounded-full" [class]="getConnectionStatusColor()"></span>
          {{ getConnectionStatusText() }}
        </div>
      }
    </div>
  </div>

  <nav class="mt-4 flex items-center gap-2 overflow-x-auto pb-1 text-sm text-slate-600">
    <button
      class="inline-flex items-center gap-2 rounded-lg px-3 py-2 font-medium transition-colors"
      [class.bg-sky-100]="vistaActiva() === 'chats'"
      [class.text-sky-700]="vistaActiva() === 'chats'"
      [class.ring-1]="vistaActiva() === 'chats'"
      [class.ring-sky-200]="vistaActiva() === 'chats'"
      [class.hover:bg-slate-100]="vistaActiva() !== 'chats'"
      (click)="seleccionarVista('chats')"
    >
      <span class="text-base">&#9675;</span>
      Chats
    </button>
    <button
      class="inline-flex items-center gap-2 rounded-lg px-3 py-2 font-medium transition-colors"
      [class.bg-sky-100]="vistaActiva() === 'flujos'"
      [class.text-sky-700]="vistaActiva() === 'flujos'"
      [class.ring-1]="vistaActiva() === 'flujos'"
      [class.ring-sky-200]="vistaActiva() === 'flujos'"
      [class.hover:bg-slate-100]="vistaActiva() !== 'flujos'"
      (click)="seleccionarVista('flujos')"
    >
      <span class="text-base">&#9971;</span>
      Flujos
    </button>
    <button
      class="inline-flex items-center gap-2 rounded-lg px-3 py-2 font-medium transition-colors"
      [class.bg-sky-100]="vistaActiva() === 'campanas'"
      [class.text-sky-700]="vistaActiva() === 'campanas'"
      [class.ring-1]="vistaActiva() === 'campanas'"
      [class.ring-sky-200]="vistaActiva() === 'campanas'"
      [class.hover:bg-slate-100]="vistaActiva() !== 'campanas'"
      (click)="seleccionarVista('campanas')"
    >
      <span class="text-base">&#9992;</span>
      Campañas
    </button>
    <button
      class="inline-flex items-center gap-2 rounded-lg px-3 py-2 font-medium transition-colors"
      [class.bg-sky-100]="vistaActiva() === 'configuracion'"
      [class.text-sky-700]="vistaActiva() === 'configuracion'"
      [class.ring-1]="vistaActiva() === 'configuracion'"
      [class.ring-sky-200]="vistaActiva() === 'configuracion'"
      [class.hover:bg-slate-100]="vistaActiva() !== 'configuracion'"
      (click)="seleccionarVista('configuracion')"
    >
      <span class="text-base">&#9881;</span>
      Configuración
    </button>
  </nav>
</header>
